<template>
  <v-row>
    <v-col cols="12">
      <Form
        dispatch="projectMeteringStore/meterStore/update"
        button_title="update"
        button_icon="mdi-pencil"
        :meter="meter"
        :resource-loading="!meter.id"
        permission="meter.update"
      ></Form>
    </v-col>
  </v-row>
</template>

<script>
import Form from "./FormMeter";
export default {
  name: "EditMeter",
  components: {
    Form
  },
  computed: {
    meter: {
      get() {
        return this.$store.getters["projectMeteringStore/meterStore/getItem"];
      }
    }
  }
};
</script>

<style scoped></style>
